import { instanceOf } from 'prop-types';

import { formatMessageTime } from 'utils/formatMessageTime';

import { MessageMetaWrapper } from './MessageMetaWrapper';

export const MessageTime = ({ datetime, ...rest }) => (
  <MessageMetaWrapper {...rest}>
    {formatMessageTime(datetime)}
  </MessageMetaWrapper>
);

MessageTime.propTypes = {
  /**
   * Datetime of the reply
   */
  datetime: instanceOf(Date).isRequired,
};
